export default __webpack_public_path__ + "static/media/element-benefits.eef60f42.svg";